import { render, staticRenderFns } from "./growth_level_edit.vue?vue&type=template&id=2c979f55&scoped=true"
import script from "./growth_level_edit.vue?vue&type=script&lang=js"
export * from "./growth_level_edit.vue?vue&type=script&lang=js"
import style0 from "./growth_level_edit.vue?vue&type=style&index=0&id=2c979f55&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c979f55",
  null
  
)

export default component.exports